import { render, staticRenderFns } from "./FullTextUrlProvider.vue?vue&type=template&id=2965f2c0&scoped=true&"
import script from "./FullTextUrlProvider.vue?vue&type=script&lang=js&"
export * from "./FullTextUrlProvider.vue?vue&type=script&lang=js&"
import style0 from "./FullTextUrlProvider.vue?vue&type=style&index=0&id=2965f2c0&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2965f2c0",
  null
  
)

export default component.exports